import axios from 'axios'
import { Message, Loading } from 'elementui-lts'
import Joi from 'joi' // Add schema validation

const ConfigBaseURL = 'https://crbwebsite.ynhdkc.com/'
let loadingInstance = null

// Create schema validation for API responses
const responseSchema = Joi.object().unknown(true)

export const Service = axios.create({
  timeout: 7000,
  baseURL: ConfigBaseURL,
  method: 'post',
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

// Request interceptor
Service.interceptors.request.use(config => {
  loadingInstance = Loading.service({
    lock: true,
    text: 'loading...'
  })
  return config
})

// Response interceptor with schema validation
Service.interceptors.response.use(response => {
  loadingInstance.close()

  // Validate response data against schema
  const { error, value } = responseSchema.validate(response.data)
  if (error) {
    console.error('Schema validation error:', error)
    return Promise.reject(new Error('Invalid response data'))
  }

  return value
}, error => {
  console.log('TCL: error', error)
  const msg = error.Message !== undefined ? error.Message : ''
  Message({
    message: '网络错误' + msg,
    type: 'error',
    duration: 3 * 1000
  })
  loadingInstance.close()
  return Promise.reject(error)
})
